const joinWithOr = (arr) => {
  if (!arr.length) return '';
  if (arr.length === 1) return arr[0];
  return arr.slice(0, -1).join(', ') + (arr.length > 1 ? ' or ' : '') + arr.slice(-1);
};

export default joinWithOr;
